import {useCallback} from "react";
import {useNavigate} from "react-router-dom";
import {ZendeskAPI} from "react-zendesk";

import {useAppDispatch, resetAll} from "~/modules/redux";
import {LOGIN_PATH} from "~/modules/routing";
import {client} from "~/api/baseApi";
import {api} from "~/api/generated";
import {useLocalStorage} from "~/hooks";

export const useAuth = (): [boolean, (v: any, opt?: object) => void, () => void] => {
  const [authToken, setAuthToken, removeAuthToken] = useLocalStorage("TOKEN");
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const isAuthorized = !!authToken;

  const setAuth = useCallback(
    (value: any) => {
      client.setHeader("authorization", value ? `Bearer ${value}` : "");
      setAuthToken(value);
    },
    [setAuthToken],
  );

  const resetAuth = useCallback(() => {
    removeAuthToken();
    dispatch(api.util.resetApiState());
    dispatch(resetAll());
    ZendeskAPI("webWidget", "logout");
    navigate(LOGIN_PATH, {replace: true});
  }, [removeAuthToken, dispatch, navigate]);

  return [isAuthorized, setAuth, resetAuth];
};
